export default __webpack_public_path__ + "static/bentoSectionImg1-967d55f5e060d844dd18ecb333276df6.webp";